export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';

export const FETCH_SECTORS_REQUEST = 'FETCH_SECTORS_REQUEST';
export const FETCH_SECTORS_SUCCESS = 'FETCH_SECTORS_SUCCESS';
export const FETCH_SECTORS_FAILURE = 'FETCH_SECTORS_FAILURE';

export const FETCH_CATEGORIES_ALL_REQUEST = 'FETCH_CATEGORIES_ALL_REQUEST';
export const FETCH_CATEGORIES_ALL_SUCCESS = 'FETCH_CATEGORIES_ALL_SUCCESS';
export const FETCH_CATEGORIES_ALL_FAILURE = 'FETCH_CATEGORIES_ALL_FAILURE';
export const UPDATE_CATEGORIES_ORDER = 'UPDATE_CATEGORIES_ORDER';

export const FETCH_CATEGORIES_TOP_REQUEST = 'FETCH_CATEGORIES_TOP_REQUEST';
export const FETCH_CATEGORIES_TOP_SUCCESS = 'FETCH_CATEGORIES_TOP_SUCCESS';
export const FETCH_CATEGORIES_TOP_FAILURE = 'FETCH_CATEGORIES_TOP_FAILURE';

export const FETCH_PRODUCT_BY_ID_REQUEST = 'FETCH_PRODUCT_BY_ID_REQUEST';
export const FETCH_PRODUCT_BY_ID_SUCCESS = 'FETCH_PRODUCT_BY_ID_SUCCESS';
export const FETCH_PRODUCT_BY_ID_FAILURE = 'FETCH_PRODUCT_BY_ID_FAILURE';
export const CLEAR_CURRENT_PRODUCT = 'CLEAR_CURRENT_PRODUCT';

export const FETCH_PRODUCT_LIST_REQUEST = 'FETCH_PRODUCT_LIST_REQUEST';
export const FETCH_PRODUCT_LIST_SUCCESS = 'FETCH_PRODUCT_LIST_SUCCESS';
export const FETCH_PRODUCT_LIST_FAILURE = 'FETCH_PRODUCT_LIST_FAILURE';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';
